import { BigNumber, BigNumberish } from '@ethersproject/bignumber'
import { formatUnits } from '@ethersproject/units'
import { platformFee, platformLVTFee } from 'config'

export function amountAfterLVTFees(amount: number, excludeFee = false) {
  if (excludeFee) return amount
  return amount * (1 - platformLVTFee / 10000)
}

export function amountAfterFees(amount: number, excludeFee = false) {
  if (excludeFee) return amount
  return amount * (1 - platformFee / 10000)
}

export const getFeeBN = (value: string) => {
  const fee = BigNumber.from(value).mul(platformFee.toString()).div('10000')
  return fee
}

export function isAddressEqual(add1 = '', add2 = '') {
  try {
    return add1.toLowerCase() === add2.toLowerCase()
  } catch (e) {
    return false
  }
}
export function isAddressContained(addr = '', array: string[] = []) {
  try {
    for (let i = 0; i < array.length; i++) {
      if (isAddressEqual(addr, array[i])) return true
    }
  } catch (e) {
    //
  }
  return false
}

export const parseBalance = (
  value: BigNumberish,
  decimals = 18,
  decimalsToDisplay = 3
) => parseFloat(formatUnits(value, decimals)).toFixed(decimalsToDisplay)

export function shortenHex(hex: string, length = 4) {
  return `${hex.substring(0, length + 2)}…${hex.substring(hex.length - length)}`
}

export function formatBlockExplorerLink(
  type: 'address' | 'tx' | 'token',
  data: [number, string]
) {
  const [chainId, address] = data
  const blockExplorerUrl =
    chainId === 1
      ? 'etherscan.io'
      : chainId === 3
      ? 'ropsten.etherscan.io'
      : chainId === 4
      ? 'rinkeby.etherscan.io'
      : chainId === 56
      ? 'bscscan.com'
      : chainId === 137
      ? 'polygonscan.com'
      : chainId === 80001
      ? 'mumbai.polygonscan.com'
      : chainId === 43114
      ? 'snowtrace.io'
      : 'etherscan.io'
  return `https://${blockExplorerUrl}/${type}/${address}`
}
